import React, { useState, useEffect, useRef } from 'react'
import WilliamImge from "../../assets/william-background.png";
import WilliamImge2 from "../../assets/william-background2.png";
import SecondBackgroundImge from "../../assets/second-background.jpg";
import PowerLineBanner from "../../assets/Powerline-main.jpg";
import SmallIConPower from "../../assets/updated-icons.png";
import LegecyBackground from "../../assets/legacy-background-image.jpg";
import ProsperityImage from "../../assets/prosperityImage.png";
import purposeImage from "../../assets/purposeImage.png";
import LongevityImage from "../../assets/LongevityImage.png";
import rebon from "../../assets/rebon.png"
import kayak from "../../assets/kayak.png"
import wave from "../../assets/wave.png"
import NewHeader from "../Neweheader";
import logo from "../../assets/logo.png"
import './newhome.css';
import PowerlineForm from '../powerline/PowerlineForm';
import kingnew from "../../assets/new-updated-image.png";
import Certainty from "../../assets/Certainty_1.png";
import Playicon from "../../assets/playicon.png";
import Arrowicon from "../../assets/arrowicon.png";
import VideoPlayer from '../../Common/Components/VideoPlayer';
import DialogComponent from '../../Inputs/DailogComponent';
import Player from '@vimeo/player';
import { useNavigate } from 'react-router-dom';
import { storeAssigned } from '../../services/Methods/normalMethods';
import footerlogo from '../../assets/footer-image.png';



const videos = {
    legacy: "https://player.vimeo.com/video/1083143189?autoplay=1&autopause=0&controls=true",
    longevity: "https://player.vimeo.com/video/1064119559?autoplay=1&autopause=0&controls=true",
    abundant: "https://player.vimeo.com/video/1064352451?autoplay=1&autopause=0&controls=true",
    passionate: "https://player.vimeo.com/video/1057650843?autoplay=1&autopause=0&controls=true",
    life_on_mission: "https://player.vimeo.com/video/1064121583?autoplay=1&autopause=0&controls=true"
};

const NewHome = () => {

    const [openVideoPopup, setOpenVideoPopup] = useState(true);
    const navigate = useNavigate();

    const homevideo = 'https://player.vimeo.com/video/1074005918?autoplay=1&loop=0&autopause=0&controls=true&mute=0';

    const secondhomevideo = 'https://player.vimeo.com/video/1064121589?autoplay=1&loop=1&autopause=0&muted=1&controls=true&background=1';

    const [activeVideo, setActiveVideo] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [currentVideo, setCurrentVideo] = useState(null);

    const openPopup = (videoKey) => {
        setCurrentVideo(videos[videoKey]);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setCurrentVideo(null);
    };

    const iframeRef = useRef(null);
    const playerRef = useRef(null);

    useEffect(() => {
        if (isPopupOpen && iframeRef.current) {
            playerRef.current = new Player(iframeRef.current);
            playerRef.current.on('ended', () => setIsPopupOpen(false));
        }

        return () => {
            if (playerRef.current) playerRef.current.off('ended');
        };
    }, [isPopupOpen]);

    const [player, setPlayer] = useState(null);
    const [isMuted, setIsMuted] = useState(true);
    useEffect(() => {
        if (iframeRef.current) {
            const vimeoPlayer = new Player(iframeRef.current);
            setPlayer(vimeoPlayer);
            vimeoPlayer.setVolume(0).then(() => {
                setIsMuted(true);
            });
        }

        return () => {
            if (player) {
                player.destroy();
            }
        };
    }, []);
    const toggleMute = () => {
        if (player) {
            const newMutedState = !isMuted;
            player.setVolume(newMutedState ? 0 : 1).then(() => {
                setIsMuted(newMutedState);
            });
        }
    };

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            setTimeout(() => {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        }
    }, []);

    return (
        <>
            <section className="hero_banner relative">
                <div className=" relative pb-[38%] ">
                    <iframe
                        ref={iframeRef}
                        src="https://player.vimeo.com/video/1074005918?autoplay=1&loop=0&autopause=0&muted=1&controls=0&background=1"
                        frameBorder="0"
                        allow="autoplay; fullscreen"
                        allowFullScreen
                        className="w-full h-full"
                    ></iframe>
                    <button
                        id="mute-toggle"
                        className="
          absolute top-4 left-1/2 transform -translate-x-1/2
          bg-black bg-opacity-60 text-white 
          px-4 py-2 rounded-md text-sm
          hover:bg-opacity-80 z-10
          sm:px-5 sm:py-2 sm:text-base
          md:px-6 md:py-3 md:text-lg
        "
                        onClick={toggleMute}
                    >
                        {isMuted ? 'Unmute' : 'Mute'}
                    </button>

                </div>
                <div className="inner-div flex flex-col justify-end mt-[20px]">
                    <div className="video_btn absolute xl:bottom-[40px] bottom-[10px] left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        {/* <button className="md:text-[16px] text-[14px] border-[3px] border-[#C5A65F] text-[#C5A65F] uppercase p-2 max-w-[max-content] mx-auto leading-normal font-semibold transition duration-300 ease-in-out hover:bg-[#000]">
                            Life On Mission
                        </button> */}
                    </div>
                </div>
            </section>



            <section className="experience_sec xl:pt-[70px] pt-[50px]">
                <div className='container xl:max-w-[1380px] mx-auto px-[15px]'>
                    <div className="relative iner-div bg-no-repeat bg-center xl:bg-cover !bg-contain xl:h-[790px] lg:h-[690px] md:h-[500px] h-[400px]" style={{ backgroundImage: `url(${WilliamImge})`, backgroundSize: "998px", backgroundPosition: "left" }}>

                        <div className="left-div md:max-w-[500px] max-w-full w-full relative xl:left-[150px] ">
                            <h2 className="md:text-left text-center font-osw xl:text-[90px] lg:text-[70px] md:text-[50px] text-[40px] font-normal text-[#5E5E5E] leading-[1]">EXPERIENCE</h2>
                            <h4 className="md:text-left text-center xl:text-[49.5px] lg:text-[38px] md:text-[28px] text-[22px] font-normal text-[#5E5E5E] leading-[1]">LIFE ON MISSION</h4>
                        </div>

                        <div className="right-div md:max-w-[510px] max-w-full w-full text-center absolute top-[210px] xl:-right-[160px] italic">
                            <p className="text-[#5E5E5E] xl:text-[24px] text-[20px] leading-[30px] font-semibold">“The great use of life is to spend it for something that will outlast it.”</p>
                            <p className="text-[#5E5E5E] xl:text-[24px] text-[20px] leading-[30px] mt-[30px] font-semibold">— William James</p>
                        </div>

                    </div>
                </div>
            </section>




            {/* <section className="xl:h-[795px] lg:h-[690px] md:h-[500px] h-[400px] bg-no-repeat bg-center bg-cover flex items-end relative " style={{ backgroundImage: `url(${SecondBackgroundImge})` }} >

                <div className="video_btn flex flex-col max-w-[max-content] mx-auto justify-center text-center">
                    <button onClick={() => openPopup("life_on_mission")} className="md:text-[16px] text-[14px] mb-[30px] border-[3px] border-[#C5A65F] text-[#C5A65F] uppercase p-2 max-w-[max-content] mx-auto leading-normal font-semibold transition duration-300 ease-in-out hover:bg-[#000]">Life On Mission</button>
                </div>
            </section> */}
            {/* 
            <section className="hero_banner relative">
                <div className=" relative pb-[38%] ">
                    <VideoPlayer className="top-0 left-0 " url={secondhomevideo} style={{ width: '100%', height: '100%', right: 0, }} />
                </div>
                <div className="inner-div flex flex-col justify-end mt-[20px]">
                    <div className="video_btn absolute xl:bottom-[40px] bottom-[10px] left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        <button className="md:text-[16px] text-[14px] border-[3px] border-[#C5A65F] text-[#C5A65F] uppercase p-2 max-w-[max-content] mx-auto leading-normal font-semibold transition duration-300 ease-in-out hover:bg-[#000]">
                            Life On Mission
                        </button>
                    </div>
                </div>
            </section> */}


            {/* <section className="xl:pt-[160px] lg:pt-[80px] pt-[50px]"> */}
            <section className="pt-[50px]">
                <div className='container max-w-[1380px] mx-auto px-[15px]'>
                    {activeVideo === "legacy" ? (
                        <div className="w-full pb-[56%] relative comon_video">
                            <VideoPlayer url={videos.legacy} className="w-full h-full rounded-lg" />
                        </div>
                    ) : (
                        <div className="relative first-div">
                            <img src={LegecyBackground} alt="Legacy Background" className="w-full h-auto" />

                            <div className="md:absolute xl:top-[70px] top-[20px] xl:right-[100px] right-[15px] p-6 bg-white shadow-lg rounded-lg md:max-w-[500px]">
                                <h2 className="font-osw text-[#000] xl:text-[49px] lg:text-[40px] text-[30px] font-normal text-center xl:leading-[60px] leading-[1.4]">
                                    HOW WE BUILD LEGACY
                                </h2>
                                <img className="flex mx-auto mt-2" src={SmallIConPower} alt="Power Icon" />


                                <button
                                    onClick={() => openPopup("legacy")}
                                    className="gap-[10px] mt-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029] transition duration-300 ease-in-out hover:bg-[#af8d3d] hover:text-[#000]"
                                >
                                    WATCH VIDEO
                                    <span>
                                        <img className='w-[23px] h-[23px] object-contain' src={Playicon} alt="Play Icon" />
                                    </span>
                                </button>

                            </div>
                        </div>
                    )}


                    {/* {activeVideo === "longevity" ? (
                        <div className="mt-[15px] w-full pb-[56%] relative comon_video">
                            <VideoPlayer url={videos.longevity} className="w-full h-full rounded-lg" />
                        </div>
                    ) : (
                        <div className="second-div relative xl:mt-[74px] mt-[50px]">
                            <img src={LongevityImage} alt="" />
                            <div className="discri_sec md:max-w-[376px] text-center md:absolute top-[50%] md:-translate-y-[50%]  xl:left-[100px] left-[15px] md:bg-transparent bg-white md:shadow-none shadow-lg md:p-[0] p-[24px]">
                                <h2 className="text-[#000000] xl:text-[49px] lg:text-[40px] text-[30px] font-normal text-center font-osw xl:leading-[60px] leading-[1.4]">VIBRANT LONGEVITY PRODUCTS</h2>
                                <h5 className="#000 text-[25px] xl:mb-[56px] mb-[30px] font-osw">For Pure Cellular Energy</h5>
                                <button
                                    onClick={() => openPopup("longevity")}
                                    className="gap-[10px] mt-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000]">WATCH VIDEO <span><img className='w-[23px] h-[23px] object-contain' src={Playicon} alt="" /></span></button>

                                <button onClick={() => navigate(`/${storeAssigned()}/longevity`)} className="xl:mt-[30px] mt-[12px] gap-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000] uppercase">learn more <span><img className='w-[23px] h-[23px] object-contain' src={Arrowicon} alt="" /></span></button>


                            </div>
                        </div>
                    )}


                    {activeVideo === "abundant" ? (
                        <div className="mt-[15px] w-full pb-[56%] relative comon_video">
                            <VideoPlayer url={videos.abundant} className="w-full h-full rounded-lg" />
                        </div>
                    ) : (
                        <div className="third-div relative xl:mt-[74px] mt-[50px]">
                            <img src={ProsperityImage} alt="" />
                            <div className="discri_sec md:max-w-[435px] text-center md:absolute top-[50%] md:-translate-y-[50%] xl:right-[100px] right-[15px] md:bg-transparent bg-white md:shadow-none shadow-lg md:p-[0] p-[24px]">
                                <h2 className="text-[#000000] xl:text-[49px] lg:text-[40px] text-[30px] font-normal text-center font-osw xl:leading-[60px] leading-[1.4]">ABUNDANT PROSPERITY SYSTEM</h2>
                                <h5 className="#000 text-[25px] xl:mb-[56px] mb-[30px] font-osw">Income Opportunity</h5>
                                <button
                                    onClick={() => openPopup("abundant")}
                                    className="gap-[10px] mt-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000]">WATCH VIDEO <span><img className='w-[23px] h-[23px] object-contain' src={Playicon} alt="" /></span></button>

                                <button onClick={() => navigate(`/${storeAssigned()}/prosperity`)} class="xl:mt-[30px] mt-[12px] gap-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000] uppercase">learn more <span><img className='w-[23px] h-[23px] object-contain' src={Arrowicon} alt="" /></span></button>
                            </div>
                        </div>
                    )}


                    {activeVideo === "passionate" ? (
                        <div className="mt-[15px] w-full pb-[56%] relative comon_video">
                            <VideoPlayer url={videos.passionate} className="w-full h-full rounded-lg" />
                        </div>
                    ) : (
                        <div className="forth-div relative xl:mt-[74px] mt-[50px]">
                            <img src={purposeImage} alt="" />
                            <div className="discri_sec md:max-w-[406px] text-center md:absolute top-[50%] md:-translate-y-[50%] xl:left-[100px] left-[15px] md:bg-transparent bg-white md:shadow-none shadow-lg md:p-[0] p-[24px]">
                                <h2 className="text-[#000000] xl:text-[49px] lg:text-[40px] text-[30px]  font-normal text-center font-osw xl:leading-[60px] leading-[1.4]">PASSIONATE PURPOSE TRAINING</h2>
                                <h5 className="#000 xl:text-[25px] text-[22px] mt-[15px] mb-[40px] font-osw">It’s What You Where Born For</h5>
                                <button
                                    onClick={() => openPopup("passionate")}
                                    className="gap-[10px] mt-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000]">WATCH VIDEO <span><img className='w-[23px] h-[23px] object-contain' src={Playicon} alt="" /></span></button>

                                <button onClick={() => navigate(`/${storeAssigned()}/purpose`)} class="xl:mt-[30px] mt-[12px] gap-[10px] bg-[#c8a666] mx-auto flex xl:text-[24px] lg:text-[20px] text-[18px] text-[#000] leading-normal max-w-[351px] w-full text-center justify-center items-center xl:min-h-[76px] min-h-[56px] shadow-[3px_3px_8px_#00000029;] transition duration-300 ease-in-out hover:bg-[#af8d3d]  hover:text-[#000] uppercase">learn more <span><img className='w-[23px] h-[23px] object-contain' src={Arrowicon} alt="" /></span></button>
                            </div>
                        </div>
                    )} */}
                </div>
                <img className="ribon-img relative md:-mt-[110px]" src={rebon} alt="" />
            </section>

            <section className='contact-fom p-[130px_0_75px] bg-no-repeat bg-center xl:bg-cover !bg-contain relative -mt-[90px]' style={{ backgroundImage: `url(${WilliamImge2})`, backgroundSize: "1530px", backgroundPosition: "center top" }}>
                <div className='overlay absolute top-[90px] left-0 w-full h-[62%] bg-[#F6F7FB] opacity-[0.80] z-[1] md:shadow-none shadow-lg md:p-[0] p-[24px]'></div>
                <div id="signup-form" className='container max-w-[1380px] mx-auto px-[15px] relative z-[2]'>

                    <div className="title">
                        <h2 className="font-osw text-[#000000] xl:text-[70px] lg:text-[60px] md:text-[40px] text-[30px] font-normal text-center font-osw xl:leading-[104px] leading-normal">Would You Like To Learn More?</h2>
                        <h3 className='xl:text-[50px] lg:text-[40px] md:text-[30px] text-[20px]  text-[#000000] lg:leading-[60px] leading-[1.2] text-center xl:mt-[27px] mt-[20px] xl:mb-[25px] mb-[15px]'>Receive Immediate Access To</h3>
                        <h3 className='mb-[37px] xl:text-[50px] lg:text-[40px] md:text-[30px] text-[20px]  text-[#000000] lg:leading-[60px] leading-[1.2] text-center'>Detailed Information</h3>
                    </div>

                    <div className="form">
                        <PowerlineForm />
                    </div>

                    <div className="gift relative xl:pt-[107px] md:pt-[80px] pt-[30px]">
                        <img className=" xl:absolute -top-[165px] mx-auto mb-[30px] left-0 xl:w-[20%] w-auto" src={kingnew} alt="king" />
                        <img className='xl:absolute -top-[165px] right-0  mx-auto xl:mb-[0] mb-[30px] xl:w-[20%] w-auto' src={Certainty} alt="" />
                        <h2 className='mb-[10px] font-osw xl:text-[36px] text-[30px] text-[#000] text-center leading-[46px]'>ABSOLUTE CERTAINTY</h2>
                        <h3 className='xl:mb-[60px] mb-[30px] font-osw text-[26px] text-[#000] text-center leading-[36px]'>A Gift For Our Visitors</h3>
                        <p className='mb-[30px] text-center xl:text-[28px] lg:text-[22px] md:text-[20px] text-[18px] xl:leading-[40px] leading-[1.2] text-[#000]'>Receive FREE digital download samples of Dr. Bill Greenman’s life-changing e-books: The Principles of ABSOLUTE CERTAINTY & GLUTATHIONE King of the Master Molecules of Health, when you click the blue “Learn More Now!” button above.
                            {/* <span className='italic'>Absolute Certainty</span>, when you click the blue Get Started button above. */}
                        </p>
                        <p className='xl:text-[28px] lg:text-[22px] md:text-[20px] text-[18px] xl:leading-[40px] leading-[1.2] text-center'>Dr. Greenman's books are compiled from his more than 50 years of personal experience. They will help you understand the power and significance of Glutathione, as well as eliminate doubt about any decision you may ever need to make.</p>
                    </div>


                </div>
            </section>


            <section className="boat-sec relative z-[1]">
                <img src={kayak} alt="" className='w-full' />
                <img className="wave absolute xl-bottom-[120px] lg-bottom-[80px] -bottom-[50px] left-0 w-full" src={wave} alt="" />
            </section>
            {isPopupOpen && (
                <div className="video-popup-overlay">
                    <div className="video-popup-content">
                        <button className="close-button" onClick={() => setIsPopupOpen(false)}>
                            &times;
                        </button>
                        <iframe
                            src={currentVideo}
                            ref={iframeRef}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Embedded Video"
                            className="video-iframe"
                        ></iframe>
                    </div>
                </div>
            )}

        </>
    )
}

export default NewHome;